// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

import Dropdown from '@stimulus-components/dropdown'
application.register('dropdown', Dropdown)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import AddressController from "./address_controller"
application.register("address", AddressController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import WithdrawalFormController from "./withdrawal_form_controller"
application.register("withdrawal-form", WithdrawalFormController)

import TrxGuideController from "./trx_guide_controller"
application.register("trx-guide", TrxGuideController)

import FloatingChatController from "./floating_chat_controller"
application.register("floating-chat", FloatingChatController)

import WithdrawalTickerController from "./withdrawal_ticker_controller"
application.register("withdrawal-ticker", WithdrawalTickerController)

import TinyMCEController from "./tinymce_controller"
application.register("tinymce", TinyMCEController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import ScreenshotController from "./screenshot_controller"
application.register("screenshot", ScreenshotController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import RebateCalculatorController from "./rebate_calculator_controller"
application.register("rebate-calculator", RebateCalculatorController)